<template>
<div class="career-cont">
  <div class="career-top">
  <div class="background-overlay"></div>
  <div class="career-heading">
    <h1>Join Our Team</h1>
    <p>If you are passionate about technology, have a goal-driven mentality and a proven track record of success, we want you on our team!</p>
  </div>
</div>
<div class="career-form">
<h2>Apply for positions that match your expertise</h2>
<div class="form-cont">
<select>
  <option>Accounting</option>
  <option>Design</option>
  <option>Business Development</option>
  <option>IT</option>
  <option>Marketing</option>
</select>
<input type="text" placeholder="First Name">
<input type="text" placeholder="Last Name">
<input type="email" placeholder="Email">
<textarea placeholder="Briefly explain why you are applying"></textarea>
<input type="text" placeholder="Link to your Linkedin page">
<input class="file-upload" type="file" name="resume" id="file-upload">
<label for="file-upload" id="file-upload-label">
  <img src="../../../public/image/uploadResumeButton.svg" alt="Upload File">
</label>
<button class="claim-button" type="submit">Send Application</button>
</div>
</div>
</div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'Careers',
      titleTemplate: '%s',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Turkish Restaurant is a unique portal where you can find the most delicious traditional Turkish dishes of the United States.'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
.career-cont{
  padding:0 20px;
}
  .career-top {
    background-image: url('../../../public/image/locations/office.jpg');
    background-size:cover;
    width:100%;
    min-height: 200px;
    display:flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .background-overlay{
      background:#fff;
      opacity:0.8;
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height: 100%;
      z-index: 1;
    }
  }
  .career-heading{
    z-index:2;
    color:#000;
    width:60%;
    h1{
      font-size:32px;
      font-weight: 900;
    }
    p{
      font-size:18px;
    }
  }
  
  .career-form{
    margin-top:20px;
    .form-cont{
      margin:20px 0px;
        select, input, textarea{
          width:100%;
          padding:10px;
          font-size:13px;
          margin-bottom:15px;
          border-radius: 7px;
          border:1px solid #ccc;
          font-family: inherit;
        }
        textarea{
          min-width:100%;
          max-width: 100%;
          min-height: 100px;
        }
    }
  }
  .claim-button{
  padding:10px 15px;
  width:max-content;
  border-radius: 7px;
  background-color:#f24405;
  color:#fff;
  font-weight: 600;
  cursor:pointer;
  &:hover{
    background-color:#e23f04;
  }
}
button.claim-button{
  border:none;
}
#file-upload {
  display: none;
}

#file-upload-label {
  display: block;
  cursor: pointer;
  margin-bottom:10px;
}

#file-upload-label img {
  width: 140px;
  height: auto;
}
@media (max-width:768px){
  .career-heading{
    width:90%;
  }
  #file-upload-label{
    text-align:center;
  }
  #file-upload-label img {
  width: 200px;
  height: auto;
}
.claim-button{
  width:100%;
}
}
</style>
